import { Modal } from 'antd'
import { getStorage } from './tools';
import { LockCodeEnum, LockConfig } from '@/config/constant';
import { getUrl, ResCodeEnum } from './request';
import qs from 'qs';
import { getDocLock } from '@/pages/documentCompile/api/data-lock';

interface LockParams {
  code: string;
  resourceId: string | number;
  requestId?: string;
  timeToLive?: number;
}

interface WithLockOptions {
  lockCode: string;
  requestId: string;
  resourceId: string | number;
  onLockFree: (requestId: string) => void; // 可编辑时回调
  onLockExists?: (requestId: string) => void; // 被锁时可选回调（如只读跳转）
}

/**
 * 统一处理资源锁逻辑
 */
export async function withResourceLock(options: WithLockOptions) {
  const params: LockParams = {
    code: options.lockCode,
    resourceId: options.resourceId,
    requestId: options.requestId,
    timeToLive: LockConfig.editLockTime,
  };

  try {
    const res = await getDocLock(params);
    if (res?.code === ResCodeEnum.RequestResourceLocked) {
      const match = res.msg?.match(/\[(.*?)\]/);
      const user = match?.[1]?.split('_')[0] ?? '';
      Modal.confirm({
        title: `用户「${user}」正在编辑此资源，您将以只读模式打开。确认继续吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk() {
          options.onLockExists?.(options.requestId);
        },
      });
    } else if (res?.code === ResCodeEnum.ProjectInitializing) {
      Modal.warning({
        title: '项目正在初始化，请稍后再试',
      });
    } else {
      options.onLockFree(options.requestId);
    }
  } catch (err) {
    console.error('锁检查失败:', err);
  }
}

export const releaseDocumentLock = async ({ requestId, resourceId, isEditable }) => {
  if (!isEditable) return;
  const token = getStorage('token');
  const data = {
    code: LockCodeEnum.PROJECT,
    resourceId,
    requestId,
    'access-token': token
  };
  const postUrl = getUrl('/cmp-doc/operator-lock/lock/release');
  const qsStr = qs.stringify(data);
  navigator.sendBeacon(`${postUrl}?${qsStr}`);
}
